import { BudgetBys } from 'business/constants';
import React, { ReactElement, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { IntegrationContext } from 'routes/BudgetModule/components/BudgetWithProvider/IntegrationContext';
import { getResourceType } from 'routes/BudgetModule/helpers/budgetProposalHelpers';
import { Tooltip } from '@mui/material';
import { isCustomBudgetProposal } from '../../hooks/budgetProposal';

/**
 * Projection tooltip displayed explaining why input is disabled.
 */
export const ProjectionTooltip = ({
    disabledByResource,
    disabledByBudgetProposal = false,
    disabled = false,
    by,
    defaultTitle,
    children,
}: {
    disabledByResource: boolean;
    disabledByBudgetProposal?: boolean;
    disabled?: boolean;
    by: BudgetBys;
    children: ReactElement;
    defaultTitle?: string;
}) => {
    const { t } = useTranslation();
    const integrations = useContext(IntegrationContext);
    const isSchool = isCustomBudgetProposal(integrations);

    if (
        !disabledByResource &&
        !disabled &&
        !defaultTitle &&
        !disabledByBudgetProposal
    )
        return <>{children}</>;

    let title;

    const resourceType = isSchool
        ? t('budgetProposal.schoolResource')
        : t(`budget.${getResourceType(by)}`);

    if (disabledByBudgetProposal) {
        title = t('budgetProposal.updateDisabledByBudgetProposal');
    } else if (disabledByResource) {
        title = t('budgetProposal.updateDisabledByRights', {
            resourceType,
        });
    } else if (disabled) {
        title = t('projection.noBudgetLine');
    } else {
        title = defaultTitle;
    }
    return (
        <Tooltip disableInteractive title={title}>
            {children}
        </Tooltip>
    );
};
